<app-header></app-header>
<div class="container-fluid" style="text-align:center;" *ngIf="paymentError">
  <h2 style="color:#00355F;padding-top:28vh;" class="heading">We are unable to process your payment.</h2>
  <div class="login">
    <div class="login-form">
      <button class="w3-btn button" (click)="goHome()" role="button">HOME</button><br>
    </div>
  </div>
</div>